import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react"; 
import "../Styles/Header.css";

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="main-header">
      <motion.div 
        className="header-container"
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        {/* Logo Image + Text */}
        <motion.div 
          className="logo-section"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          <img 
            src="/latest-logo.jpeg"  
            alt="GoldenStays Logo" 
            className="logo-img"
          />
          {/* <span className="logo-title">Wego Homes</span> */}
        </motion.div>

        {/* Desktop navigation */}
        <nav className="nav desktop-nav">
          <motion.a 
            href="/" 
            className="nav-link"
            whileHover={{ scale: 1.1 }}
          >
            Home
          </motion.a>

          <span className="dot">•</span>

          <motion.a 
            href="/properties" 
            className="nav-link"
            whileHover={{ scale: 1.1 }}
          >
            All Listings
          </motion.a>
        </nav>

        {/* Mobile Hamburger Icon */}
        <div className="mobile-menu-icon" onClick={() => setOpen(true)}>
          <Menu size={26} />
        </div>
      </motion.div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {open && (
          <motion.div 
            className="mobile-nav"
            initial={{ y: -200, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -200, opacity: 0 }}
            transition={{ duration: 0.4 }}
          >
            <div className="mobile-header-row">

              <div className="logo-section-small">
                <img 
                  src="/logo-image.jpeg" 
                  alt="Logo" 
                  className="logo-img-small"
                />
                <span className="logo-title-small">GoldenStays</span>
              </div>

              <X size={28} onClick={() => setOpen(false)} className="close-icon" />
            </div>

            <a 
              href="/" 
              className="mobile-link"
              onClick={() => setOpen(false)}
            >
              Home
            </a>

            <a 
              href="/properties" 
              className="mobile-link"
              onClick={() => setOpen(false)}
            >
              All Listings
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
